/* Theme-owned containers only; Shopify wallet internals are never changed. */
(function(root,factory){
 'use strict';
 if(typeof module==='object'&&module.exports)module.exports=factory();else root.NikuyaCartAccelerated=factory();
})(typeof globalThis!=='undefined'?globalThis:this,function(){
 'use strict';
 function suppress({context,snapshot,pending=false,unresolved=false,policy,needsReview=false,discountReady=false}={}){
  if(!context||!snapshot||snapshot.authoritative!==true||!Array.isArray(snapshot.items)||pending||unresolved)return true;
  if(policy==='KNIFE_ONLY_20260924'){
   // The no-gift provider checks the current offer and explicit cart review.
   // A retained acquisition context must not gate a paid-only cart on that code.
   return needsReview;
  }
  if(!['NO_CONTEXT','EXPIRED','SUPPRESSED'].includes(context.status))return true;
  return snapshot.items.some(l=>l.managedLooking||Object.keys(l.properties||{}).some(k=>k.startsWith('_nikuya_')));
 }
 function mount({document,read}={}){
  let generation=0;
  const hide=value=>document.documentElement.classList.toggle('nikuya-accelerated-suppressed',value);
  hide(true);
  async function refresh(){const id=++generation;hide(true);try{const state=await read();if(id===generation)hide(suppress(state))}catch(_){}}
  return Object.freeze({refresh});
 }
 return Object.freeze({suppress,mount});
});
